import axios from 'axios';

const baseUrl = 'https://knit-oss-mgn-rmkxbquhlf.cn-hangzhou.fcapp.run';

interface WebConfig {
  scoID: string,
  pic_key: string,
  pic_dataID: string,
  dispalyname: string
}

interface EnterpriseInfo {
  'address': string
  'order_address': string
  'name': string
  'type': 'qingflow' | 'cloud',
  'imageUrl': string,
  'webConfig': WebConfig | null,
}

export async function getEnterpriseById(enterpriseId: string): Promise<EnterpriseInfo> {
  try {
    const response = await axios.get(`${baseUrl}/v1/enterprise/${enterpriseId}`);
    return response.data;
  } catch (error: any) {
    console.log(error);
    const errorMessage = error.response?.data?.message || 'An unexpected error occurred';
    return Promise.reject(new Error(errorMessage));
  }
}